var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirewall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-firewall-1{fill:#4285f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_FirewallRules_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 1.98,
    y: 2,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 1.98,
    y: 19.78,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 1.98,
    y: 10.89,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 13.09,
    y: 2,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 13.09,
    y: 19.78,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 13.09,
    y: 10.89,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 7.53,
    y: 6.44,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 7.53,
    y: 15.33,
    width: 8.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 1.98,
    y: 6.44,
    width: 3.33,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 1.98,
    y: 15.33,
    width: 3.33,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 18.65,
    y: 6.44,
    width: 3.33,
    height: 2.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-firewall-1",
    x: 18.65,
    y: 15.33,
    width: 3.33,
    height: 2.22
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewall);
export default __webpack_public_path__ + "static/media/firewall.7d2cea10988002c340c972ff99072e02.svg";
export { ForwardRef as ReactComponent };